export default {
  id: 'dashboard',
  title: 'Dashboard and analytics (admin)',
  note: 'Operator dashboard landing page and the system analytics screen. Numbers, log output, RICS codes and API error messages are not part of this catalogue.',
  texts: {
    // ── Dashboard ──────────────────────────────────────────────────────────
    'dashboard.crumb': 'Dashboard',
    'dashboard.title': 'Operator dashboard',
    'dashboard.head.sub': 'System-wide overview · {date}',

    'dashboard.action.period': 'This month',
    'dashboard.action.periodTitle': 'Open analytics for full period selection',
    'dashboard.action.export': 'Export',
    'dashboard.action.exportTitle': 'Export dashboard snapshot as CSV',
    'dashboard.action.newReport': 'New G6 report',
    'dashboard.action.newReportTitle': 'Go to G6 Reports to generate a new one',

    'dashboard.export.row.companies': 'Total companies',
    'dashboard.export.row.partnerships': 'Active partnerships',
    'dashboard.export.row.transactions': 'Transactions',
    'dashboard.export.row.users': 'Platform users',
    'dashboard.export.column.metric': 'Metric',
    'dashboard.export.column.value': 'Value',

    'dashboard.error.load': 'Failed to load dashboard',

    'dashboard.kpi.companies.label': 'Total companies',
    'dashboard.kpi.companies.delta': 'live',
    'dashboard.kpi.companies.sub': 'registered carriers',
    'dashboard.kpi.partnerships.label': 'Active partnerships',
    'dashboard.kpi.partnerships.delta': 'live',
    'dashboard.kpi.partnerships.sub': 'agreements',
    'dashboard.kpi.partnerships.subEmpty': 'no agreements yet',
    'dashboard.kpi.transactions.label': 'Transactions',
    'dashboard.kpi.transactions.delta': 'live',
    'dashboard.kpi.transactions.sub': 'processed',
    'dashboard.kpi.transactions.subEmpty': 'no transactions yet',
    'dashboard.kpi.users.label': 'Platform users',
    'dashboard.kpi.users.delta': 'live',
    'dashboard.kpi.users.sub': 'with active accounts',

    'dashboard.revenue.title': 'Cleared revenue',
    'dashboard.revenue.sub': '14-day trend · demo data',

    'dashboard.status.title': 'Transaction status',
    'dashboard.status.sub': 'Current month · demo',

    'dashboard.partners.title': 'Partner balances',
    'dashboard.partners.sub': 'Top 6 by activity · demo',
    'dashboard.partners.viewAll': 'View all',

    'dashboard.activity.title': 'Activity',
    'dashboard.activity.sub': 'System events · {state}',
    'dashboard.activity.state.live': 'live',
    'dashboard.activity.state.demo': 'demo (no real activity yet)',
    'dashboard.activity.allEvents': 'All events',
    'dashboard.activity.fallbackTitle': 'Activity',

    // ── Analytics ──────────────────────────────────────────────────────────
    'analytics.crumb': 'Analytics',
    'analytics.title': 'System analytics',
    'analytics.head.sub': 'Live system health, user activity and per-company metrics · {state}',
    'analytics.head.refreshed': 'refreshed {time}',
    'analytics.head.loading': 'loading…',
    'analytics.action.refresh': 'Refresh',
    'analytics.action.refreshBusy': 'Refreshing…',

    'analytics.error.load': 'Failed to load analytics',

    'analytics.section.systemHealth': 'System Health',
    'analytics.section.businessData': 'Business Data',
    'analytics.section.serverLogs': 'Server Logs',

    'analytics.kpi.heap.label': 'JVM Heap',
    'analytics.kpi.heap.unit': 'MB',
    'analytics.kpi.heap.sub': 'of {max} MB · {pct}% used',
    'analytics.kpi.rss.label': 'RSS Memory',
    'analytics.kpi.rss.unit': 'MB',
    'analytics.kpi.rss.sub': 'JVM committed',
    'analytics.kpi.dbPool.label': 'DB Pool Active',
    'analytics.kpi.dbPool.sub': 'of {max} max · {idle} idle',
    'analytics.kpi.requests.label': 'API Requests',
    'analytics.kpi.requests.sub': 'avg latency {ms} ms',
    'analytics.kpi.sessions.label': 'Active Sessions',
    'analytics.kpi.sessions.sub': '{keys} Redis keys total',
    'analytics.kpi.uptime.label': 'Uptime',
    'analytics.kpi.uptime.sub': 'since last restart',

    'analytics.kpi.companies.label': 'Companies',
    'analytics.kpi.users.label': 'Users',
    'analytics.kpi.users.sub': '{admins} admins · {active} active',
    'analytics.kpi.partnerships.label': 'Partnerships',
    'analytics.kpi.transactions.label': 'Transactions',
    'analytics.kpi.usageEvents.label': 'Usage Events',

    'analytics.users.title': 'Users',
    'analytics.users.sub': '{total} total · sorted by created date',
    'analytics.users.column.user': 'User',
    'analytics.users.column.role': 'Role',
    'analytics.users.column.company': 'Company',
    'analytics.users.column.status': 'Status',
    'analytics.users.status.active': 'active',
    'analytics.users.status.disabled': 'disabled',

    'analytics.companies.title': 'Companies by activity',
    'analytics.companies.sub': 'Transactions where company is seller or supplier',
    'analytics.companies.column.company': 'Company',
    'analytics.companies.column.rics': 'RICS',
    'analytics.companies.column.transactions': 'Transactions',
    'analytics.companies.column.share': 'Share',

    'analytics.logs.title': 'Backend log tail',
    'analytics.logs.sub': '{lines} lines · {size} KB',
    'analytics.logs.lines100': '100 lines',
    'analytics.logs.lines200': '200 lines',
    'analytics.logs.lines500': '500 lines',
    'analytics.logs.lines1000': '1000 lines',
    'analytics.logs.lines5000': '5000 lines',
    'analytics.logs.filterPlaceholder': 'Filter…',
    'analytics.logs.refresh': 'Refresh',
    'analytics.logs.refreshBusy': 'Loading…',
    'analytics.logs.download': 'Download .log',
    'analytics.logs.error.load': 'Failed to load logs',
    'analytics.logs.error.download': 'Download failed',
    'analytics.logs.error.downloadAlert': 'Download failed: ',
    'analytics.logs.empty.noMatch': 'No lines match "{filter}"',
    'analytics.logs.empty.none': 'No logs available',

    'analytics.footer': 'Auto-refresh every {seconds}s · backend `/api/admin/analytics/*`',
  },
}
